import React from "react";
import logo from "../../../assets/images/inc-logo.png";
import "../../../assets/css/style.css";
import LicesneOrga from "../../../assets/images/licenseOrganization.png";
import LicenseUser from "../../../assets/images/licesnseUser.png";
import LicenseSucess from "../../../assets/images/licenseSucess.png";
import LicenseLogin from "../../../assets/images/licenseLogin.png";
import SubUser from "../../../assets/images/subUser.png";
import SubUser2 from "../../../assets/images/subUser2.png";
import SubUser3 from "../../../assets/images/subUser3.png";
import SubUser4 from "../../../assets/images/subUser4.png";
import SubUser5 from "../../../assets/images/subUser5.png";
import SubUser6 from "../../../assets/images/subUser6.png";
import SubUser7 from "../../../assets/images/subUser7.png";

const UserDetails = () => {
  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <h3 className="inc-heading">
            Post-Installation Instructions for INC
          </h3>

          <div className="inc-card-body">
            <h4 className="inc-blue-heading">
              1. One-Time Access Credentials for Admin Onboarding
            </h4>
            <p>
              After installing the INC platform, log in using the one-time
              preset credentials provided below. This login is intended solely
              for initial access. Upon logging in, please complete the entire
              user onboarding process. The user who completes this flow will be
              designated as the Organization Admin, holding the highest level of
              access within the system.
              <p style={{ paddingLeft: "2em" }}>
                <strong>Credentials:</strong>{" "}
              </p>
              <p style={{ paddingLeft: "2em" }}>
                <strong>Username:</strong> incx@incx.in
              </p>
              <p style={{ paddingLeft: "2em" }}>
                <strong>Password:</strong> 1NcX@2026{" "}
              </p>
              <p style={{ paddingLeft: "2em" }}>
                {" "}
                ⚠️ Note: These credentials are valid for one-time use only. Make
                sure to complete onboarding without interruptions.
              </p>{" "}
              <br />
              <img
                src={LicenseLogin}
                className="helpLicesne-img"
                alt="Customer Overview"
              />
              <br />
              <h4 className="inc-blue-heading">
                2. Organization and Admin User Information
              </h4>
              <p style={{ paddingLeft: "2em" }}>
                Next, fill in your organization details (e.g., organization
                name, address, other information) and your user details (e.g.,
                first name , last name , other details r).
              </p>
              <br />
              <img
                src={LicesneOrga}
                className="helpLicesne-img"
                alt="Customer Overview"
              />
              <br />
              <h4 className="inc-blue-heading">
                {" "}
                3. Create Your Permanent Admin Credentials
              </h4>
              <p style={{ paddingLeft: "2em" }}>
                After that, provide your email address and password — these will
                become your permanent admin account credentials and will be used
                for all future logins.
              </p>
              <p style={{ paddingLeft: "2em" }}>
                ⚠️ Make sure to enter valid and secure information, as this
                account will serve as the primary Organization Admin.
              </p>
              <br />
              <img
                src={LicenseUser}
                className="helpLicesne-img"
                alt="Customer Overview"
              />
              <br />
              <p style={{ paddingLeft: "2em" }}>
                After submitting the required details, you will be redirected to
                the login page.
              </p>
              <p style={{ paddingLeft: "2em" }}>
                At this point, use your newly created credentials (email and
                password) to log in.
              </p>
              <p style={{ paddingLeft: "2em" }}>
                A confirmation email will also be sent to your registered email
                address.
              </p>
              <h4 className="inc-blue-heading">
                4. Successful Registration Confirmation
              </h4>
              <p style={{ paddingLeft: "2em" }}>
                ✅ You have now successfully created your permanent Organization
                Admin account.
              </p>
              <br />
              <img
                src={LicenseSucess}
                className="helpLicesne-img"
                alt="Customer Overview"
              />
              <br />
            </p>
            <br />
            <br />
            <br />
            <div className="inc-card-title">
              <h3>Sub User / add your organization user</h3>
            </div>
            <br />
            <p style={{ paddingLeft: "2em" }}>
              To add a new user, navigate to the User Management section located
              in the left sidebar, as shown in the image below.
            </p>
            <p style={{ paddingLeft: "2em" }}>
              From there, you can create, edit, or manage users within your
              organization.
            </p>
            <br />

            <img
              src={SubUser}
              className="helpLicesne-img"
              alt="Customer Overview"
            />

            <br />

            <p style={{ paddingLeft: "2em" }}>
              Click on the Add User button on the right side of the page
            </p>
            <br />
            <img
              src={SubUser2}
              className="helpLicesne-img"
              alt="Customer Overview"
            />
            <br />
            <p style={{ paddingLeft: "2em" }}>
              To add a user, enter their Name, Address, and assign a Role.
            </p>
            <p style={{ paddingLeft: "2em" }}>
              We currently support two roles:
            </p>
            <ul style={{ paddingLeft: "4em" }}>
              <li>
                <strong>role_site_admin</strong> – Full administrative
                privileges
              </li>
              <li>
                <strong>role_site_user</strong> – Standard user access
                <br />
                You can explore and manage these roles further in the Roles
                section.
              </li>
              <li>
                ⚙️ Assign roles carefully based on the level of access the user
                should have.
              </li>
            </ul>
            <p style={{ paddingLeft: "2em" }}>
              Email will be sent to user for setting up the credential
            </p>
            <br />

            <img
              src={SubUser7}
              className="helpLicesne-img"
              alt="Customer Overview"
            />
            <br />
            <img
              src={SubUser6}
              className="helpLicesne-img"
              alt="Customer Overview"
            />
            <br />

            <p style={{ paddingLeft: "2em" }}>
              After Filling all the details you will get the success message
            </p>
            <br />
            <br />
          </div>

          <footer>
            <div className="container">
              Powered by{" "}
              <a
                href="https://www.vvdntech.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                VVDN Technologies
              </a>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default UserDetails;
